'use client';

import { c as _c } from "react/compiler-runtime";
import { useSignedMutation } from '@achra/sdk/react';
import { useQueryClient } from '@tanstack/react-query';
import type { BuilderDriveLink } from '@/modules/__generated__/graphql/switchboard-generated';
import { driveLinkFor } from '@/modules/shared/lib/switchboard-urls';
type SpinUpPersonaId = 'operator' | 'builder';
interface SpinUpDriveInput {
  personaId: SpinUpPersonaId;
  name: string;
  ensName?: string;
}
function useSpinUpDrive() {
  const $ = _c(2);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = {
      mutationFn: _temp,
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ["GetBuilderDrives"]
        });
        queryClient.invalidateQueries({
          queryKey: ["GetBuilderDrivesSuspense"]
        });
      }
    };
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useSignedMutation(t0);
}
async function _temp(t0, t1) {
  const {
    personaId,
    name,
    ensName
  } = t0;
  const {
    signer,
    address,
    client
  } = t1;
  const result = await client.workspaces.ensure(personaId === "operator" ? ["builder", "operator"] : ["builder"], {
    signer,
    address,
    name,
    ensName
  });
  const driveSlug = result.builderDriveSlug ?? "";
  return {
    __typename: "BuilderDriveLink",
    driveId: result.builderDriveId ?? "",
    driveSlug,
    driveName: result.builderDriveName ?? "",
    driveLink: driveLinkFor(driveSlug),
    builderProfileId: result.builderProfileId
  };
}
export { useSpinUpDrive };
export type { SpinUpDriveInput, SpinUpPersonaId };